var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"code"},[_c('prism-editor',{staticClass:"my-editor",attrs:{"highlight":_vm.highlighter,"line-numbers":""},on:{"focus":_vm.Focus,"blur":_vm.Blur},model:{value:(_vm.code),callback:function ($$v) {_vm.code=$$v},expression:"code"}}),_c('div',{staticClass:"save",on:{"click":_vm.saveChange}},[_vm._v("保存")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }